import { useLang } from '@/i18n';
import EFPicture from '@elem/ui/ef-picture';
import { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useState } from 'react';
import PartnerModal from '../PartnerModal';
import EarlyBird from '../EarlyBird';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';

export default function Comp() {
    const { t } = useLang('theProduct.BannerC');
    const [modalVisible, setModalVisible] = useState(false);

    const dataC: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1752811734826/BannerC-pc.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1752811753599/BannerC-h5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1752811753599/BannerC-h5.jpg',
    };

    const handleClick = () => {
        setModalVisible(true);
        gtm.push({
            __btn_id1: styles.comp,
            __btn_id2: t(`btn`),
        });
    };

    return (
        <div className={`${styles.comp} GtmModuleData-section`} id="BannerC" data-section-id={styles.comp} data-section-title={t('title')}>
            {/* <EcoBanner {...dataC} /> */}
            <EFPicture
                src="https://websiteoss.ecoflow.com/upload/image/1752811734826/BannerC-pc.jpg"
                srcPad="https://websiteoss.ecoflow.com/upload/image/1752811753599/BannerC-h5.jpg"
                srcMobile="https://websiteoss.ecoflow.com/upload/image/1752811753599/BannerC-h5.jpg"
                className="banner"
            />
            <div className="text-container">
                <h1>{t('title')}</h1>
                <div className="desc">{t(`desc`)}</div>
                <EarlyBird endTime={new Date('2025/12/31 23:59:59 GMT+8').getTime()} />
                <div onClick={handleClick} className="link GtmModuleData-btn-text">
                    {t(`btn`)}
                </div>
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
}
